import $ from 'jquery';
import _ from 'lodash';
import { getState, getStatePure } from '~src/state';
import { isLoggedUserGlobalEditor } from '~src/user';
import { editorConfig } from '~config';
import { canvasJsonToImage } from '~core';
import { handleChangePageBtn } from '~src/multipages';
import { FEATURES, isFeatureEnabled } from '../features';
import { isCurrentPage } from './currentPageImage';
import {
  PAGE_THUMBNAIL_SIZE,
  updateSidebarPageThumbnail,
} from './generateCurrentPageThumbnail';

let missingThumbnailsRun = Promise.resolve();

// Le pagine mai aperte senza anteprima salvata non hanno un'immagine da
// mostrare: la miniatura si disegna dal loro canvasJson, una alla volta e
// senza bloccare la sidebar. La pagina aperta la riceve dal debounce.
const renderMissingThumbnails = async () => {
  const pages = getState('pages') || [];

  for (const page of pages) {
    if (page.thumbnail || _.get(page, 'preview.url') || isCurrentPage(page)) {
      continue;
    }

    try {
      const { base64 } = await canvasJsonToImage(page.canvasJson, {
        quality: 0.8,
        outputDpi: 72,
        cleanBase64String: false,
        maxSize: PAGE_THUMBNAIL_SIZE,
      });
      page.thumbnail = base64;
      updateSidebarPageThumbnail(getState('pages').indexOf(page), base64);
    } catch (error) {
      console.warn('Cannot generate page preview', error);
    }
  }
};

export const addPagesToSidebar = async () => {
  const isGlobalEditor = await isLoggedUserGlobalEditor();
  const canUserAddPages = await isFeatureEnabled(FEATURES.ADD_PAGES);

  const pages = getStatePure('pages');
  const currentPageIndex = getState('currentPageIndex');
  let pageIndex = 0;

  const html = pages.reduce((acc, page) => {
    // imgData è l'immagine di stampa a piena risoluzione: nella sidebar
    // basta la miniatura.
    const pagePreviewUrl =
      page.thumbnail ||
      _.get(page, 'preview.url', editorConfig.pagePreviewPlaceholder);
    const template = `
          <div class="editor-sidebar-item-container ${
            pageIndex === currentPageIndex ? 'editor-sidebar-page-current' : ''
          }" data-page-index="${pageIndex}" id="editor-page-${pageIndex}">
                  <div class="editor-sidebar-slides-pagination"><span>${
                    pageIndex + 1
                  }</span></div>
                  <div class="editor-sidebar-page-preview">
                      <img src="${pagePreviewUrl}" />
                  </div>
                  <div
                    id="editor-sidebar-sub-menu-${pageIndex}"
                    class="editor-sidebar-item-sub-menu-container  editor-sidebar-item-page">
                    <button
                      id="btn-page-delete-${pageIndex}"
                      class="btn btn-sidebar-pages-delete editor-pages-box-delete"
                      data-page-btn-index="${pageIndex}"
                      data-page-url="${pagePreviewUrl}"> ELIMINA
                    </button>
                  </div>
              </div>
              `;

    acc += template;
    pageIndex++;
    return acc;
  }, '');
  if (isGlobalEditor || canUserAddPages) {
    const htmlButton = `
        <div class="sidebar-box-btns-area d-flex">
          <button id="editor-menu-editable-page" class="buttonSidebarDouble btn-ofc-secondary-blue m-1">
            Modifica
          </button>
  
          <button id="editor-menu-add-page" class="buttonSidebarDouble btn-ofc-secondary-blue m-1">
            Aggiungi
          </button>
        </div>`;
    $('#btn-manage-pages').html(htmlButton);
  }

  $('#editor-sidebar-pages').html(html);

  $('body').off('click', '[data-page-index]');
  $('body').on('click', '[data-page-index]', handleChangePageBtn);
  // makePagesDraggable();

  missingThumbnailsRun = missingThumbnailsRun
    .then(renderMissingThumbnails)
    .catch((error) => console.warn('Cannot generate page previews', error));
};
